export const FETCH_POINTS_EXPIRE = 'FETCH_POINTS_EXPIRE';
export const FETCH_POINTS_EXPIRE_SUCCESS = `${FETCH_POINTS_EXPIRE}_SUCCESS`;
export const FETCH_POINTS_EXPIRE_FAIL = `${FETCH_POINTS_EXPIRE}_FAIL`;

const pointsExpireReducer = (
  state = {
    isLoading: false,
    isLoaded: false,
  },
  action = {},
) => {
  const { data: data1 } = action.payload || { data: null };
  switch (action.type) {
    case FETCH_POINTS_EXPIRE:
      return { ...state, isLoading: true };
    case FETCH_POINTS_EXPIRE_SUCCESS:
      if (data1 === null) {
        return { ...state };
      }

      return {
        ...state,
        pontosExpirar30: data1.retorno[0].pontosExpirar30,
        safraExpirar30: data1.retorno[0].safraExpirar30.split(' ')[0],
        pontosExpirar60: data1.retorno[0].pontosExpirar60,
        safraExpirar60: data1.retorno[0].safraExpirar60.split(' ')[0],
        pontosExpirar90: data1.retorno[0].pontosExpirar90,
        safraExpirar90: data1.retorno[0].safraExpirar90.split(' ')[0],
        pontosExpirar120: data1.retorno[0].pontosExpirar120,
        safraExpirar120: data1.retorno[0].safraExpirar120.split(' ')[0],
        isLoading: false,
        isLoaded: true,
      };
    case FETCH_POINTS_EXPIRE_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default pointsExpireReducer;
